import AbhishekImage from '../assets/Abhishek.png'
import AriakaImage from '../assets/Ariaka.png'
import KanishkImage from '../assets/Kanishk.png'
import KshitizImage from '../assets/kshitiz.png'
import RidhimaImage from '../assets/Ridhima.png'
import RohitAgarwalImage from '../assets/Rohit Agarwal.jpg'
import SomiSoni from '../assets/SomSoni.jpeg'
import UtkarshImage from '../assets/Utkarsh.png'
import VedanshImage from '../assets/vedansh.png'
import VedantImage from '../assets/Vedant.png'

export const BrochureLink =
  'https://drive.google.com/file/d/1HhXS6VIibBZ2rgXSQoYY-tJRGD_dWiIG/view?usp=sharing\n'

export const stepNameToStepNumber: Record<string, number> = {
  verify_phone: 0,
  fill_pd: 1,
  fill_ed: 2,
  preview: 3,
  pay_reg_fee: 4,
  test: 5,
  interview: 6,
  completed: 7
}

export const stepNameToStepLabel: Record<string, string> = {
  verify_phone: 'Signed Up',
  fill_pd: 'Phone Verified',
  fill_ed: 'Application Form Started',
  preview: 'Application Form Filled',
  pay_reg_fee: 'Application Form Filled',
  test: 'Paid Registration Fee',
  interview: 'Cleared Test',
  completed: 'Interview'
}

export const ApplicationFormSteps = [
  { id: 'fill_pd', name: 'Personal Details', status: 'current' },
  {
    id: 'fill_ed',
    name: 'Educational details',
    status: 'upcoming'
  },
  { id: 'preview', name: 'Preview', status: 'upcoming' }
]

export const OverallSteps = [
  {
    id: 'application_form',
    name: 'Application Form',
    description: 'Vitae sed mi luctus laoreet.',
    status: 'current'
  },
  {
    id: 'pay_reg_fee',
    name: 'Registration Fee',
    description: 'Cursus semper viverra facilisis et et some more.',
    status: 'upcoming'
  },
  {
    id: 'test',
    name: 'Scholarship Test',
    description: 'Penatibus eu quis ante.',
    status: 'upcoming'
  },
  {
    id: 'interview',
    name: 'Interview',
    description: 'Faucibus nec enim leo et.',
    status: 'upcoming'
  },
  {
    id: 'completed',
    name: 'Result',
    description: 'Faucibus nec enim leo et.',
    status: 'upcoming'
  }
]

export const keyToLabelPersonalDetails: Record<string, string> = {
  name: 'Name',
  phone: 'Phone No.',
  dob: 'Date of Birth',
  email: 'Email',
  gender: 'Gender',
  parent_name: 'Parent Name',
  parent_phone: 'Parent Phone No.',
  parent_email: 'Parent Email'
}

export const keyToLabelEducationalDetails: Record<string, string> = {
  high_school_board: '10th Board',
  high_school_name: '10th School Name',
  high_school_passing_year: '10th Passing Year',
  high_school_result: '10th Result',
  diploma_university_name: 'Diploma University Name',
  diploma_passing_year: 'Diploma Passing Year',
  diploma_result: 'Diploma Result',
  higher_secondary_board: '12th Board',
  higher_secondary_school_name: '12th School Name',
  higher_secondary_passing_year: '12th Passing year',
  higher_secondary_result: '12th Result'
}

export const mentors = [
  {
    name: 'Rohit Agarwal',
    avatar: RohitAgarwalImage.src,
    desc: 'Tech Architect, First Engineer at Oyo'
  },
  {
    name: 'Som Soni',
    avatar: SomiSoni.src,
    desc: 'Engineering Manager at Google'
  },
  {
    name: 'Vedansh',
    avatar: VedanshImage.src,
    desc: 'Ex- Hackerrank, CoFounder Devsnest'
  },
  {
    name: 'Kshitiz',
    avatar: KshitizImage.src,
    desc: 'Ex- Amazon, CoFounder Devsnest'
  }
]

export const HighSchoolBoardTypes = [
  { id: 'cbse', label: 'CBSE' },
  { id: 'icse', label: 'ICSE' },
  { id: 'other_board', label: 'Other' }
]

export const HigherSecondaryBoardTypes = [
  { id: 'cbse_hs', label: 'CBSE' },
  { id: 'icse_hs', label: 'ICSE' },
  { id: 'other_hs_board', label: 'Other' }
]

export const HigherEducationTypes = [
  { id: 'higher_secondary', label: ' 12' },
  { label: 'Diploma', id: 'diploma' }
]

export const testimonials = [
  {
    name: 'Kanishk Pachauri',
    avatar: KanishkImage.src,
    role: 'Incoming Google SDE',
    text: 'With Devsnest, I learnt the importance of collaboration and the art of dissecting a problem to solve it in the best possible manner.'
  },
  {
    name: 'Abhishek Saran',
    avatar: AbhishekImage.src,
    role: 'DevOps Engineer at Zoom',
    text: 'Devsnest provided such a community which helped me to grew more accountable. It made learning more fun.'
  },
  {
    name: 'Araika Singh',
    avatar: AriakaImage.src,
    role: 'SWE @Visa',
    text: 'Devsnest provided such a community which helped me to grew more accountable. It made learning more fun.'
  },
  {
    name: 'Utkarsh Nagdev',
    avatar: UtkarshImage.src,
    role: 'SDE @Amazon',
    text: 'Every day at Devsnest was fun learning with a group of like-minded people, together was really exciting.'
  },
  // {
  //   name: 'Rahul Verma',
  //   avatar: RahulImage.src,
  //   role: 'TPA at Juspay',
  //   text: 'Every day at Devsnest was fun learning with a group of like-minded people, together was really exciting.'
  // },
  // {
  //   name: 'Rushali Sarkar',
  //   avatar: RushaliImage.src,
  //   role: 'D.E Shaw',
  //   text: 'Devsnest made me realize a single company can never be a goal, but learning the skills with perfection is.'
  // },
  {
    name: 'Vedant Jain',
    avatar: VedantImage.src,
    role: 'SDE-2, Disney+HotStar',
    text: 'Joining Devsnest was one of the best decisions I have made so far. Devsnest made me the Engineer  I always wanted to be.'
  },
  {
    name: 'Ridhima Kapoor',
    avatar: RidhimaImage.src,
    role: 'SDE-1 at Expedia Group',
    text: 'I am grateful to Devsnest, for helping me understand my potential. The group projects with peers made learning easy and effortless.'
  }
]
